import { ErrorCode } from 'models/error-code.models';

export const errorResources: { [code: number]: string } = {
  '-1': 'Une erreur inattendue est survenue.',
  1: 'Le serveur est momentanement injoignable.',
  401: 'Vous avez été deconnecté.',
  1001: "Erreur lors de la récupération d'un email.",
  2002: "Nom d'utilisateur ou mot de passe invalide.",
  2012: "Vous n'avez pas de compte associé au service de téléphonie",
  3001: "Votre lien n'est plus valide.",
  3003: 'Vous ne pouvez pas réutiliser le même mot de passe.',
  [ErrorCode.NotFound.Client]: "Le client n'existe pas.",
  [ErrorCode.BadRequest.InvalidNaming]:
    'Veuillez verifier votre nom et votre prénom',
  3102: 'Vous avez uploadé le maximum de fichiers autorisés.',
  [ErrorCode.BadRequest.CannotUnarchiveAgencyWithSignedContract]:
    'Impossible de désarchiver une agence avec un contrat signé',
  3201: 'IBAN invalide',
  [ErrorCode.BadRequest.QuotationPayment]: 'Un paiement a déjà été effectué.',
  [ErrorCode.BadRequest.QuotationHasPaymentInProgress]:
    'Un paiement est en cours sur le devis.',
  3303: "La date d'effet est invalide",
  3505: "La date d'effet est invalide",
  [ErrorCode.NotFound.Complement]:
    "Le complément n'existe pas ou a été supprimé",
  [ErrorCode.Forbidden]: 'Droits insuffisants.',
  [ErrorCode.BadRequest.WithholdingThresholdExceeded]:
    'Attention, quota précompte dépassé !',
  [ErrorCode.BadRequest.MissingSignedPropositionFiles]:
    "Fichier demande d'adhésion signé manquant.",
  [ErrorCode.BadRequest.MissingQuotationPublicId]:
    'Erreur technique, id de quotation manquant.',
  [ErrorCode.BadRequest.UploadedFileBadExtension]:
    'Extension de fichier non prise en charge.',
  [ErrorCode.BadRequest.CannotActivatePolicy]: 'La police a déjà été activée.',
  [ErrorCode.BadRequest.InvalidForm]: 'Le formulaire est invalide.',
  [ErrorCode.BadRequest.PolicyWithoutPricing]:
    "La police n'est plus tarifiable",
  [ErrorCode.BadRequest.CannotUpdateActivatedPolicy]:
    'Impossible de mettre à jour une police déjà active.',
  [ErrorCode.BadRequest.CannotUpdatePolicyWithComplement]:
    'Un complément existe sur cette police.',
  [ErrorCode.BadRequest.ComplementAlreadyPaid]:
    'Le complément a déjà été payé.',
  [ErrorCode.BadRequest.CannotDeleteComplementWithRunningTransaction]:
    'Un paiement est en cours sur ce complément.',
  [ErrorCode.BadRequest.CannotPayTerminatedPolicy]:
    "Impossible de payer les quittances d'une police résiliée non remise en vigueur.",
  [ErrorCode.BadRequest.CannotGenerateReleveInformationForPolicyState]:
    "Impossible de générer un Relevé d'information avec le statut actuel de la quittance.",
  [ErrorCode.BadRequest.PolicyNotRenewable]:
    "La police n'est pas renouvellable.",
  [ErrorCode.BadRequest.AvenantDisabledInRenewPeriod]:
    'Les avenants tarifants sont bloqués pendant la période de renouvellement.',
  [ErrorCode.BadRequest.RequestAlreadyRequested]:
    'La demande est déjà en cours de traitement.',
  [ErrorCode.BadRequest.RequestHasOneRunningTransaction]:
    'Une transaction est déjà en cours.',
  [ErrorCode.BadRequest.MissingImmatriculationFromQuotation]:
    'Immatriculation manquante, veuillez retourner sur le devis pour saisir la saisir.',
  [ErrorCode.BadRequest.HealthInsurance_InvalidOrganismNumber]:
    "Un numéro d'organisme d'affiliation d'une personne est invalide",
  [ErrorCode.BadRequest.HealthInsurance_InvalidSSNumber]:
    "Le numéro de sécurité social d'une personne est invalide",
  [ErrorCode.BadRequest.HealthInsurance_MissingMembershipApplication]:
    "La demande d'adhésion n'a pas pu être générée. Veuillez contacter un gestionnaire.",
  [ErrorCode.BadRequest.HealthInsurance_FrancaisOrTnsOnly]:
    'Régime Obligatoire Français ou Régime TNS uniquement',
  [ErrorCode.BadRequest.AgeoAccountDoesNotExist]:
    "Votre compte n'est pas encore enregistré chez notre partenaire.",
  [ErrorCode.BadRequest.AgeoContractRefDoesNotExist]:
    "Cette référence de police n'existe pas chez notre partenaire.",
  [ErrorCode.BadRequest.AgeoContractExistsWithAnotherSubscriberName]:
    'Cette référence de police existe sous un autre nom.',
  [ErrorCode.BadRequest.CouldntParseAgeoResult]:
    "Nous n'avons pu récupérer les informations d'AGEO (format invalide)",
  [ErrorCode.BadRequest.HealthInsurance_InvalidSalesman]:
    "Votre compte n'est pas encore enregistré chez notre partenaire.",
  [ErrorCode.BadRequest.HealthInsurance_CannotUseEcoOptionWithFormula1]:
    "L'option éco ne peut pas être sélectionnée avec la formule 1.",
  [ErrorCode.BadRequest.HealthInsurance_FranceOrCorsicaOnly]:
    "La tarification n'est possible que pour la France métropolitaine ou la Corse uniquement.",
  [ErrorCode.BadRequest.HealthInsurance_MinimumAge18]:
    "L'âge minimum d'inscription est de 18 ans.",
  [ErrorCode.BadRequest.HealthInsurance_MaximumAge85]:
    "L'âge limite d'inscription est de 85 ans.",
  [ErrorCode.BadRequest.HealthInsurance_CityInvalidValue]:
    'La ville est invalide.',
  [ErrorCode.BadRequest.HealthInsurance_CityNotFound]:
    "La ville n'existe pas dans notre base de données.",
  [ErrorCode.BadRequest.HealthInsurance_InvalidNumberOfChildren]:
    "Le nombre d'enfants est invalide pour ce type de contrat.",
  [ErrorCode.BadRequest.HealthInsurance_EffectDateMustBeInFuture]:
    "La date d'effet du contrat doit être dans le futur.",
  [ErrorCode.BadRequest.HealthInsurance_InvalidEmailDomain]:
    "Le nom de domaine de l'adresse e-mail de l'assuré est invalide.",
  [ErrorCode.BadRequest.HealthInsurance_IBANInvalidKey]:
    "Le contrôle de clef de l'IBAN est invalide.",
  [ErrorCode.BadRequest.HealthInsurance_IBANClosedBankAccount]:
    'Le compte bancaire est clôturé.',
  [ErrorCode.BadRequest.HealthInsurance_IBANAlphanumericCharOnly]:
    "L'IBAN ne doit comporter que des caractères alphanumériques.",
  [ErrorCode.BadRequest.HealthInsurance_BICInvalidLength]:
    'Le BIC doit être composé de 8 ou 11 caractères.',
  [ErrorCode.BadRequest.HealthInsurance_MaritalStatus]:
    "État civil invalide car l'assuré a un conjoint.",
  [ErrorCode.BadRequest.HealthInsurance_InvalidCityAndZipCode]:
    'Le couple ville / code postal est invalide.',
  [ErrorCode.BadRequest.HealthInsurance_SalesmanNotActivated]:
    "Votre compte TunnelSante n'est pas activé pour ce produit.",
  [ErrorCode.BadRequest.LastStateIsNotTermination]:
    'Impossible de remettre en vigueur une police non résiliée.',
  [ErrorCode.BadRequest.InsuranceTypeInvalidForNppTermination]:
    'Seules les polices auto peuvent-être remise en vigueur.',
  [ErrorCode.BadRequest.TerminationNotNpp]:
    'Seules les résiliations pour non paiement de prime peuvent-être remises en vigueur.',
  [ErrorCode.BadRequest.TerminationMoreThanTwoMonthsOld]:
    'Remise en vigueur impossible lorsque la date de résiliation a plus de deux mois.',
  [ErrorCode.BadRequest.RemiseEnVigeurImpossible]:
    'Remise en vigueur impossible lorsque si dernier prélèvement échéancier dépassé.',
  [ErrorCode.BadRequest.QuotationSmsNotHandled]:
    "Sms en cours de dev, veuillez utiliser l'email",
  [ErrorCode.BadRequest.ErrorWhileCallingAagSignature]:
    'Un problème est survenue',
  5000: 'Aucun produit disponible pour ce profil.',
  11000: "Une erreur s'est produite lors de l'appel au service de téléphonie.",
  11001: 'Votre compte de service téléphonie est incorrect.',

  5001: 'Véhicule non pris en charge par nos assureurs',
  5002: 'Véhicule non pris en charge par nos assureurs',
  5003: 'Nombre de sinistres',
  5004: 'Ville non pris en charge par nos assureurs',
  5005: 'Aucun produit disponible pour ce profil',
  5006: 'Ancienneté du permis par rapport au véhicule',
  5007: 'Malussé non pris en charge pour ce profil',
  5008: 'Résiliation pour nullité non pris en charge pour ce profil',
  5009: 'Résiliation pour sinistre non pris en charge pour ce profil',
  5010: 'Résiliation pour sinistre et Non paiement de prime de 3 à 6 mois non pris en charge pour ce profil',
  5011: 'Résiliation pour sinistre et Non paiement de prime de moins de 3 mois non pris en charge pour ce profil',
  5012: 'Résiliation pour sinistre et Non paiement de prime de plus de 6 mois non pris en charge pour ce profil',
  5013: 'Véhicule non pris en charge par nos assureurs',
  5014: 'Véhicule non pris en charge par nos assureurs',
  5015: 'Véhicule non pris en charge par nos assureurs',
  5016: 'Résiliation non pris en charge pour ce profil',
  5017: 'Alcoolémie non pris en charge pour ce profil',
  5018: 'Contrôle stupéfiant non pris en charge pour ce profil',
  5019: 'Age du conducteur non pris en charge pour ce profil',
  5020: 'Véhicule non pris en charge par nos assureurs',
  5021: 'Véhicule non pris en charge par nos assureurs',
  5022: 'Véhicule non pris en charge par nos assureurs',
  5023: 'Véhicule non pris en charge par nos assureurs',
  5024: "Nombre d'année d'assurance non pris en charge pour ce profil",
  5025: 'Aucun produit disponible pour ce profil',
  5026: 'Département non pris en charge par nos assureurs',
  5027: 'Nombre de sinistres non pris en charge pour ce profil',
  5028: 'Aucun produit disponible pour ce profil',
  5029: 'Ville non pris en charge par nos assureurs',
  5030: 'Véhicule non pris en charge par nos assureurs',
  5031: 'Permis de conduire hors UE non pris en charge pour ce profil',
  5032: 'Age du permis non pris en charge pour ce profil',
  5033: 'Age du conducteur non pris en charge pour ce profil',
  5034: 'Délit de fuite non pris en charge pour ce profil',
  5035: 'Véhicule non pris en charge par nos assureurs',
  5036: 'Usage du véhicule non pris en charge pour ce profil',
  5037: 'Contrôle stupéfiant non pris en charge pour ce profil',
  5038: 'Titulaire de carte grise non pris en charge pour ce profil',
  5039: 'Véhicule trop cher et non pris en charge par nos assureurs',
  5040: 'Aucun produit disponible pour ce profil',
  5041: 'Alcoolémie non pris en charge pour ce profil',
  5042: "Nombre de mois d'assurance non pris en charge pour ce profil",
  5043: 'CRM non pris en charge pour ce profil',
  5044: 'Motif de suspension de permis non pris en charge pour ce profil',
  5045: 'Age du véhicule non pris en charge pour ce profil',
  5046: 'Marque de véhicule non pris en charge pour ce profil',
  5047: 'Aucun produit disponible pour ce profil',
  5048: "Nombre de mois d'assurance non pris en charge pour ce profil",
  5049: 'Alcoolémie non pris en charge pour un conducteur de moins de 30 ans',
  5050: 'Alcoolémie non pris en charge pour un conducteur de plus de 70 ans',
  5051: 'Sinistre et stupéfiant non pris en charge par nos assureurs',
  5052: "Nombre d'alcoolémie non pris en charge par nos assureurs",
  // 5054: '',
  // 5055: '',
  // 5056: '',
  5057: 'Nombre de sinistres responsables non pris en charge',
  5058: 'Nombre de sinistres non pris en charge',
  5059: 'Nombre de sinistres (vol) non pris en charge',
  5060: 'Nombre de sinistres matériel non pris en charge',
  5061: 'Ville non prise en charge',
  5062: 'Type de stationnement non pris en charge',
  5063: 'Type de stationnement non pris en charge',
  5064: "Bonus non pris en charge pour l'age du conducteur",
  5065: "Nombre de mois d'assurance non pris en charge pour ce profil",
  5066: "Nombre de sinistres non pris en charge pour l'age du conducteur",
  5067: 'Nombre de sinistres corporels responsables non pris en charge pour ce profil',
  5068: 'Nombre de sinistres responsables non pris en charge pour ce profil',
  5069: "Alcoolémie non prise en charge pour l'age du conducteur",
  5070: "Récidive d'aggravation non pris en charge pour ce profil",
  5071: "Pas d'aggravation pour ce profil",
  5072: 'Condamnation non pris en charge pour ce profil',
  6001: 'Il est interdit de démarcher par téléphone des consommateurs inscrits sur la liste Bloctel sauf en cas de «  relations contractuelles préexistantes ». Il est possible de démarcher par téléphone des consommateurs inscrits  sur la liste Bloctel qu’en vue de sollicitations intervenant dans le cadre de l’exécution d’un contrat en cours  et ayant un rapport avec l’objet de ce contrat, y compris lorsqu’il s’agit de proposer au consommateur des  produits ou des services afférents ou complémentaires à l’objet du contrat en cours ou de nature à améliorer ses  performances ou sa qualité',
};
